import { render, staticRenderFns } from "./IndustrialOutput.vue?vue&type=template&id=4d18748c&"
import script from "./IndustrialOutput.vue?vue&type=script&lang=ts&"
export * from "./IndustrialOutput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports